export default __webpack_public_path__ + "static/media/faqicon3.f059da1a.svg";